<template>
  <v-sheet class="promotion" style="height: calc(100vh - 140px)">
    <v-card-text class="px-0 custom_field_height">
      <v-row> 
        <v-col md="3" class="py-0 pr-0" style="max-width: 340px" v-if="false">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600"
            >Filter By Date Range</label
          >
          <DateRangePicker
            hide-details
            class="mt-3"
            v-model="range"
            :disabled="pageLoading"
            :loading="pageLoading"
            id="item-sale-duration"
            placeholder="Date Range"
          ></DateRangePicker>
        </v-col>
        <v-col class="py-0 pr-0" style="max-width: 180px; width: 180px">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600"
            >Filter by Paid Month</label
          >
          <AutoCompleteInput
            class="mt-3"
            hide-details
            :disabled="pageLoading"
            :loading="pageLoading"
            :items="months"
            id="segment"
            item-text="name"
            item-value="value"
            v-model="search_month"
             placeholder="Select Month" 
          >
          </AutoCompleteInput>
        </v-col>
        <v-col class="py-0 pr-0" style="max-width: 180px; width: 180px">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600"
            >Filter by Paid Year</label
          >
          <AutoCompleteInput
            class="mt-3"
            hide-details
            :disabled="pageLoading"
            :loading="pageLoading"
            :items="yearlist"
            id="segment" 
            v-model="search_year"
             placeholder="Select Year" 
          >
          </AutoCompleteInput>
        </v-col>
        <v-col md="3" class="mt-5 px-0">
          <v-flex>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="max-width: 10px"
                  color="blue darken-4"
                  v-on="on"
                  v-bind="attrs"
                  depressed
                  tile
                  @click="searchPromotions"
                  class="ml-2 white--text me-1 px-1"
                >
                  <v-icon>mdi-magnify</v-icon></v-btn
                >
              </template>
              <span>Filter</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="red darken-4"
                  v-on="on"
                  v-bind="attrs"
                  depressed
                  tile
                  v-on:click="reset"
                  class="ml-2 white--text me-1"
                  >Reset
                </v-btn>
              </template>
              <span>Reset </span>
            </v-tooltip>
            <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue darken-4"
                    v-on="on"
                    v-bind="attrs"
                    depressed
                    tile
                    class="ml-2 white--text"
                    ><v-icon>mdi-file-excel</v-icon></v-btn
                  >
                </template>
                <span>Export</span>
              </v-tooltip> -->
          </v-flex>
        </v-col>
        <v-col class="mt-5 justify-content-end ps-0">
          <v-flex class="d-flex justify-content-end">
           
            <v-btn
              :disabled="pageLoading"
              color="blue darken-4"
              depressed
              tile
              class="ml-2 white--text"
             v-on:click="addPayment()"
            >
              New
            </v-btn> 
            <v-menu offset-y  transition="slide-y-transition" :close-on-content-click="false" v-if="false" >
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip >
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      color="blue darken-4"
                      depressed
                      tile
                      v-bind="attrs"
                      v-on="{ ...tooltip, ...menu }"
                      class="white--text ml-2"
                    >
                      <v-icon>edit_note</v-icon>
                    </v-btn>
                  </template>
                  <span>Columns arrangement and visibility</span>
                </v-tooltip>
              </template>
              <v-list nav dense>
                <v-list-item
                  draggable
                  @dragstart="dragstart(index)"
                  @dragover="dragover(index)"
                  @dragend="dragEnd"
                  v-for="(item, index) in defaultColDefs"
                  :key="item.field + '_' + index"
                  class="flex-column column-arrangement-list-item cursor-move"
                >
                  <div class="d-flex flex-row">
                    <template v-if="!item.checkbox || Number(item.checkbox) == 0">
                      <v-checkbox
                        :ripple="false"
                        hide-details
                        color="#0d47a1"
                        v-model="defaultColShow"
                        v-bind:value="item.field"
                        :disabled="Number(item.fixed) || pageLoading"
                        v-on:change="updateVisible()"
                        class="m-0"
                      ></v-checkbox>
                      <v-list-item-title>{{ item.headerName }}</v-list-item-title>
                      <v-icon>drag_indicator</v-icon>
                    </template>
                  </div>

                  <v-divider
                    v-if="index < customThead.length - 1"
                    class="mt-1 mb-0"
                    style="width: 100%"
                  ></v-divider>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>

          
          
        </v-col>
      </v-row>
    </v-card-text>
    <SearchCriteria
      v-if="listingSearch"
      :search="listingSearch"
      search-string="Promotion #, Full Name, Email, Phone No. and Address"
      v-on:close-search="resetSearch"
    >
    </SearchCriteria>
    <v-simple-table fixed-header class="bt-table table_height">
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="heading in customThead"
              :key="heading.title"
              style="background-color: #f5f5f5"
            >
              <div v-if="heading.status">{{ heading.headerName }}</div>
            </th>
          </tr>
        </thead>
        <Draggable
          tag="tbody"
          v-model="promotions"
          class="draggable-group"
          handle=".draggable-drag-icon"
          v-on:change="updateItemOrder($event)"
        >
          <template v-if="promotions.length && promotions.length > 0">
            <tr
              v-for="(row, bkey) in promotions"
              :key="bkey"
              :class="bkey % 2 === 0 && 'blue lighten-5'"
              class="promotion-listing-tr"
            >
              <td
                v-for="(th, index) in customThead"
                :key="'key_' + index"
                :width="th.field == 'action' ? '50px' : ''"
              >
                <div v-if="th.field === 'title' && th.status">
                  <template>
                    {{ row.title }}
                  </template>

                  <!-- {{ row[getColValue(th.title)]?.value }} -->
                </div>

                <div v-else-if="th.field === 'action' && th.status">
                  <v-tooltip
                    top
                    content-class="custom-top-tooltip"
                    v-if="selectstatus == 'Active' && sequence == 1"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="draggable-drag-icon cursor-move" color="blue darken-4"
                        >mdi-drag</v-icon
                      >
                    </template>
                    <span>Order</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    content-class="custom-top-tooltip"
                  
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        fab
                        dark
                        x-small
                        class="mx-2"
                        color="green"
                        v-bind="attrs"
                        v-on="on"
                       v-on:click="updatePayment(row)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        fab
                        dark
                        x-small
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        v-on:click.stop.prevent="deleteConfirm(row)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </div>
                <div v-else-if="th.field === 'barcode' && th.status">
                  <v-chip outlined label color="indigo" v-if="row.barcode">
                    {{ row.barcode }}
                  </v-chip>  
                  <span v-if="!row.barcode" class="text-muted" style="width: 250px">
                    No barcode
                  </span>
                </div>
                <div v-else-if="th.field === 'type' && th.status">
                  <v-chip outlined label :color="row.type == '2' ? 'green' : 'red'">
                    {{ getRowtype(row.type) }}
                  </v-chip>  
                </div>
                <!-- <div v-else-if="getColValue(th.title) === 'description' && th.status">
                    {{ addElipses(text, 20).text }} &nbsp;
                    <span
                      v-if="addElipses(text, 20).readmore"
                      style="color: #24326d; cursor: pointer; font-size: 12px"
                      @click="dialog = true"
                      >Read More</span
                    >
                  </div> -->
      
                <div v-else-if="th.field === 'remark' && th.status">
                  <div v-if="row.remark" class="text-truncate" style="width: 250px">
                    {{ stripHtmlTags(row.remark) }} 
                  </div>
                  <span
                    v-if="row && row.remark && row.remark.length > 30"
                    style="color: #24326d; cursor: pointer; font-size: 12px"
                    @click="
                      remarkPop(row.remark)
                    "
                    >Read More</span>  
                  <div v-if="!row.remark" class="text-muted" style="width: 250px">
                    No Remark
                  </div>
                </div>

                <div v-else-if="th.field === 'amount' && th.status">
                
                  <div v-if="row.type == '2'" class="text-muted" style="width: 250px">
                    No Amount Provided
                  </div>
                  <div v-else class="text-truncate" style="width: 250px">
                    {{   formatMoney(row.amount) }}
                  </div>
                </div>
                <div v-else-if="th.field === 'month_name' && th.status">
                  <div class="text-sm mt-1">

                    <div>
                      <template v-if="row.full_date">  <v-chip  label color="red" >
                        <span class="text-uppercase text-light" >
                          {{  row.full_date }}</span> 
                     </v-chip>  
                    
                   
                    </template>
                    <div v-else class="text-muted" style="width: 250px">
                    No Date mentioned
                  </div>
                    </div>
                  </div>
 
                </div>

                <div v-else-if="th.field === 'created_at' && th.status">
                  <div class="text-sm mt-1">
                    <div>
                      <v-icon start size="16">mdi-calendar</v-icon>
                      {{ formatedate(row.added_at) }}
                      <VTooltip activator="parent"> Created date </VTooltip>
                    </div>
                  </div>
                  <div class="text-sm mt-1">
                    <div>
                      <v-icon start size="16">mdi-clock</v-icon>
                      {{ formateTime(row.added_at) }}
                      <VTooltip activator="parent"> Created Time </VTooltip>
                    </div>
                  </div>
                </div>

               
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="10">
                <p class="m-0 text-center">
                  <img
                    width="30"
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image mr-4"
                  />
                  Uhh... There are no rent payment at the moment.
                </p>
              </td>
            </tr>
          </template>
        </Draggable>
      </template>
    </v-simple-table>

    <Dialog :dialog="dialog" :dialogWidth="900">
      <template v-slot:title>Remark </template>
      <template v-slot:body>
        <v-row class="delete-dialog"> 
          <v-col md="10" class="py-0 my-auto">
            <p class="m-3 btx-p m-0"><b class="red--text text--lighten-1"></b>{{ stripHtmlTags(text) }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn depressed tile @click="dialog = false"> Close </v-btn>
      </template>
    </Dialog>

   
    
    <DeleteTemplate
      type="payment"
      :delete-dialog="deleteDialog"
      :delete-endpoint="deleteEndpoint"
      v-on:close="deleteDialog = false"
      v-on:delete:success="getPaymentTypes()"
    >
    </DeleteTemplate>
    <SearchTemplate
      :dialog="allCollectedDialog"
      v-on:close="allCollectedDialog = false"
    ></SearchTemplate>

    <!-- adding payment form component -->
    <CreateOrUpdatePayment
      v-model="addFormDialog"
      :payment-id="selectedPaymentId"
      :initial-data="currentPaymentDataForForm"
      form-type="rent" 
      @save-success="handleSaveSuccess"
      @closed="handleFormDialogClose"
    />

  </v-sheet>
</template>
<script>
import Dialog from "@/view/components/Dialog";
import SearchCriteria from "@/view/components/SearchCriteria";
import { GET_PAYMENT_LIST } from "@/core/lib/payment.lib";

import { SET_ERROR } from "@/core/services/store/common.module";
import DeleteTemplate from "@/view/components/DeleteTemplate";
import SearchTemplate from "@/view/components/SearchAllVouchers";
import DateRangePicker from "@/view/components/DateRangePicker";
// import PaymentHeader from "@/view/components/PaymentHeader.vue";
import Draggable from "vuedraggable";
import { PATCH } from "@/core/services/store/request.module";
import { SearchEventBus } from "@/core/lib/search.lib";

import { filter, map } from "lodash";

import { POST } from "@/core/services/store/request.module";

import {
  SET_SEARCH_TITLE,
  SET_SEARCH_MODEL,
  SET_SEARCH_BAR,
  BEFORE_DESTROY,
} from "@/core/services/store/listing.module";
import { mapGetters } from "vuex";
import { format } from "date-fns";
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import { formatMoney } from "accounting-js";

import moment from "moment-timezone";  

import CreateOrUpdatePayment from "./Create-Or-Update-Payment.vue";

export default {
  name: "payment-listing",
  title: "Listing Payment",
  props: {
    status: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectstatus: "null",
      searchParam: null,
      images: null,
      all: 0,
      defaultColDefs: [],
      customThead: [],
      active: 0,
      Inactive: 0,
      searchEnabled: null,
      list: [],
      range: null,
      search_month: null,
      search_year: null,
      yearlist: [],
      months: [
        {
          name: "January",
          value: 1,
        },
        {
          name: "February",
          value: 2,
        },
        {
          name: "March",
          value: 3,
        },
        {
          name: "April",
          value: 4,
        },
        {
          name: "May",
          value: 5,
        },
        {
          name: "June",
          value: 6,
        },
        {
          name: "July",
          value: 7,
        },
        {
          name: "August",
          value: 8,
        },
        {
          name: "September",
          value: 9,
        },
        {
          name: "October",
          value: 10,
        },
        {
          name: "November",
          value: 11,
        },
        {
          name: "December",
          value: 12,
        },
      ],
      sequence: null,
     
      dialog: false,
      dataLoading: false,

      dragStartIndex: null,
      dragOverIndex: null,
   
      template: "first",
    
      filterType: "all",
      filterDateRange: null,
      speedDial: [],
      draft: null,
   
      promotions: [],
      currentPage: 1,
      pageLimit: 1,
      showingFrom: 0,
      showingTo: 0,
      totalRows: 0,
      pageLoading: true,
      deleteText: null,
      deleteEndpoint: null,
      deleteDialog: false,
      orderDialog: false,
      rOrderId: 0,
      rOrderCode: null,
      rLoading: false,
      rVouchers: [],
      redeemDialog: false,
      cOrderId: 0,
      cOrderCode: null,
      cLoading: false,
      cVouchers: [],
      collectDialog: false,
      allCollectedDialog: false,
      order: {
        id: null,
        date: format(new Date(), "yyyy-MM-dd"),
        time: format(new Date(), "HH:mm"),
        bill_no: null,
        amount: null,
        voucher: "none",
      },

      addFormDialog: false,
      selectedPaymentId: null,
      currentPaymentDataForForm: null,
    };
  },
  watch: {
    tableHeading: {
      handler: function (newval) {
        console.log(newval);
      },
      deep: true,
    },
    currentPage() {
      this.getPaymentTypes();
    },
    listingSearch() {
      this.getPaymentTypes();
    },
    filterDateRange() {
      if (this.filterDateRange && this.filterDateRange.length > 1) {
        this.filterType = "all";
        this.getPaymentTypes();
      }
    },
  },
  methods: { 
    formatMoney(money) {
      return formatMoney(money, {
        symbol: "RM",
        decimal: ".",
        thousand: ",",
        precision: 2,
        format: "%s%v",
      });
    },
    updatePayment(row) {
      this.selectedPaymentId = row.id;
      this.currentPaymentDataForForm = {
        type: row.type ? row.type.toString() : '1',
         remark: row.remark,
         date: row.date,
         amount: row.amount,
      };
      this.addFormDialog = true;
    },
    addPayment() {
      this.selectedPaymentId = null;
      this.currentPaymentDataForForm = { 
         type: '1',
         remark: null,
         date: null,
         amount: null,
      };
      this.addFormDialog = true;
    },
    getRowtype(type) {
    switch (type) {
        case 1:
            return 'Rent';
        case 2:
            return 'Utility';
              case 3:
            return 'Refund';
        default:
            return 'Unknown';
    }
  },

    stripHtmlTags(content) {
      if (!content) return '';
      const tempElement = document.createElement('div');
      tempElement.innerHTML = content;
      return tempElement.textContent || tempElement.innerText || '';
    },
    updateVisible() {
      const _this = this;

      for (let index = 0; index < _this.defaultColDefs.length; index++) {
        const element = _this.defaultColDefs[index];
        _this.defaultColDefs[index].visible = 0;
        if (_this.defaultColShow.includes(element.field)) {
          _this.defaultColDefs[index].visible = 1;
        }
      }

      _this.$nextTick(() => {
        _this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then((data) => {
            this.customThead = data;
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.getPaymentTypes();
          });
      });
    },
    formateTime(param) {
      return moment(param).format("hh:mm A");
    },
    activeInactive(data, id) {
      const _this = this;
     
      _this.$store
        .dispatch(PATCH, {
          url: `single-promotion`,
          data: {
            id: id,
            status: Number(data),
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getPaymentTypes();
        });
    },
    reset() {
      this.search_month = null;
      this.range = null;
      this.search_year = null;
      this.getPaymentTypes();
    },

    updateItemOrder(e) {
      this.gfgdg = e;
    },

    gochange() {
      this.sequence = 0;
    },

    updateAddressPerson(param) {
      this.selectstatus = param;
      this.sequence = 0;
      this.getPaymentTypes();
    },
    remarkPop(reason) {
      this.text = reason; 
      this.dialog = true;
    },
    formatedate(param) {
      return moment(param).format("DD/MM/YYYY");
    },
    getColValue(val) {
      if (val.includes(" ")) {
        return val.split(" ").join("_").toLowerCase();
      } else {
        return val.toLowerCase();
      }
    },
    dragstart(index) {
      this.dragStartIndex = index;
    },
    dragover(index) {
      this.dragOverIndex = index;
    },
    dragEnd() {
      const dragStartElement = this.defaultColDefs[this.dragStartIndex];
      this.defaultColDefs.splice(this.dragStartIndex, 1);
      this.defaultColDefs.splice(this.dragOverIndex, 0, dragStartElement);
      this.$nextTick(() => {
        this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then((data) => {
            this.customThead = data;
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.getPaymentTypes();
          });
      });
    },
    drastart(index) {
      this.dragging_element_index = index;
    },
    addElipses(text, words) {
      if (text.length > 5) {
        if (words === 0) {
          return { text: text.slice(0, text.length), readmore: false };
        } else {
          return { text: text.slice(0, words) + "...", readmore: true };
        }
      } else {
        return { text: text.slice(0, text.length), readmore: false };
      }
    },
    getAllCollectedVouchers() {},
    filterTypeChange() {
      this.filterDateRange = null;
    },
 
  
    routeToUpdate(id) {
      this.$router.push({
        name: "payment-update",
        params: { id },
        query: { t: new Date().getTime() },
      });
    },
    routeToDetail(id) {
      this.$router.push({
        name: "promotion-detail",
        params: { id },
        query: { t: new Date().getTime() },
      });
    },
    deleteConfirm({ code, id }) {
      this.deleteText = code;
      this.deleteEndpoint = `payment-types/${id}`;
      this.deleteDialog = true;
    },
    searchPromotions() {
      this.getPaymentTypes();
    },
    async getPaymentTypes(search = null) {
      try {
        let form = {
          tab: "rent",
          current_page: this.currentPage,
          search: search,
          selectstatus: this.selectstatus,
          filter_type: this.filterType,
          search_month: this.search_month,
          search_year: this.search_year,
       
        };
        if (this.range) {
          const dateRange = {
            start_date: this.range[0],
            end_date: this.range[1],
          };
          form = { ...form, ...dateRange };
        }
        this.pageLoading = true;
        const {
          data,
          totalPages,
          showingFrom,
          showingTo,
          totalRows,

          totalPayments, 

          totalUtilities,
          totalRefundLastMonth,
          totalRefundThisMonth,
          totalRentPaidThisMonth,
          totalRentPaidLastMonth,
          totalUtilitiesThisMonth,
          totalUtilitiesLastMonth,
          total,
          allyear,
          active,
          Inactive,
          theads, 
        } = await GET_PAYMENT_LIST(form);
        this.promotions = data;
        this.pageLimit = totalPages;
        this.showingFrom = showingFrom;
        this.showingTo = showingTo;
        this.totalRows = totalRows;
        this.totalPayments = totalPayments;
        this.totalRentPaidThisMonth = totalRentPaidThisMonth;
        this.totalRentPaidLastMonth = totalRentPaidLastMonth;
        this.totalRefundLastMonth = totalRefundLastMonth;
        this.totalRefundThisMonth = totalRefundThisMonth;
        this.totalUtilities = totalUtilities;
        this.totalUtilitiesThisMonth = totalUtilitiesThisMonth;
        this.totalUtilitiesLastMonth = totalUtilitiesLastMonth;
this.yearlist = allyear;
        this.all = total;
        this.active = active; 
        this.Inactive = Inactive;
        let thead = theads;
        this.defaultColDefs = thead;
        this.customThead = [];
        for (let index = 0; index < thead.length; index++) {
          let element = thead[index];
          if (element.visible == 1 && element.field != "paid_by" && element.field != "utility_name") {
            this.customThead.push(element);
          }
        }
        let t_out = filter(thead, (row) => Number(row.visible) == 1);
        this.defaultColShow = map(t_out, "field");  
        this.$emit("saveAddress", totalRows);
        this.$emit("totalPayments",totalPayments);
        this.$emit("totalRentPaidThisMonth",totalRentPaidThisMonth);
        this.$emit("totalRentPaidLastMonth",totalRentPaidLastMonth);
        this.$emit("totalRefundLastMonth",totalRefundLastMonth);
        this.$emit("totalRefundThisMonth",totalRefundThisMonth);
        this.$emit("totalUtilities",totalUtilities);
        this.$emit("totalUtilitiesThisMonth",totalUtilitiesThisMonth);

        this.$emit("totalUtilitiesLastMonth",totalUtilitiesLastMonth);

      } catch (error) {
        this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
      } finally {
        this.pageLoading = false;
      }
    },
    resetSearch() {
      this.$router
        .replace({
          query: {
            t: new Date().getTime(),
          },
        })
        .then(() => {
          this.$store.dispatch(SET_SEARCH_MODEL, null);
        });
    },
    handleSaveSuccess() {
      this.getPaymentTypes();
    },
    handleFormDialogClose() {
      this.addFormDialog = false;
      this.selectedPaymentId = null;
      this.currentPaymentDataForForm = null;
    },
  },
  async mounted() {
    let _this = this;
    SearchEventBus.$on("start-search", (argument) => {
      _this.searchEnabled = false;
      _this.searchParam = argument;
      if (_this.searchParam) {
        _this.searchEnabled = true;
      }
      this.getPaymentTypes(argument);
    });
    SearchEventBus.$emit("search-template", true);

    this.getPaymentTypes();
    this.sequence = 0;
    this.$store.dispatch(SET_SEARCH_BAR, true);
    this.$store.dispatch(SET_SEARCH_TITLE, "Rent");
  },
  beforeDestroy() {
    this.$store.dispatch(BEFORE_DESTROY);
  },
  components: {
    DeleteTemplate,
     
    SearchTemplate,
    SearchCriteria,
    Dialog,
    DateRangePicker,
    Draggable,
    AutoCompleteInput,
    CreateOrUpdatePayment,
  },
  computed: {
    ...mapGetters(["listingSearch"]),
    modifiedTableHeading() {
      const _tableHadings = this.promotionTableHeading.filter((heading) => heading.status);
      return _tableHadings;
    },
  },
};
</script>

<style>
.table_height .v-data-table__wrapper {
  height: calc(100vh - 360px);
}

.promotion-listing-tr:nth-child(even):hover {
  box-shadow: 0px 0px 10px #666666 !important;
  -webkit-box-shadow: 0px 0px 10px #666666 !important;
  -moz-box-shadow: 0px 0px 10px #666666 !important;
  background-color: #e3f2fd !important;
  position: relative;
  z-index: 5;
}

.promotion-listing-tr:nth-child(odd):hover {
  box-shadow: 0px 0px 10px #666666 !important;
  -webkit-box-shadow: 0px 0px 10px #666666 !important;
  -moz-box-shadow: 0px 0px 10px #666666 !important;
}

.custom_field_height v-input__control {
  max-height: 34px;
  height: 34px;
}

.custom_field_height .v-select__selection {
  max-width: 84%;
}
</style>
